// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   base_uri: 'http://tools.tecnosystem.test/api',
//   base_uri_api_profit: 'http://api.profit.test',
//   base_uri_mikrowisp: 'https://demo.mikrosystem.net/api/v1',
//   token_api_mikrowisp: 'Smx2SVdkbUZIdjlCUlkxdFo1cUNMQT09',
//   token_api_profit: '1|GxmgI2Gif6HJzORlj6Tc0mMjiNlWFzbRp7W4Bxtx',
//   token_api_tools: '1|GxmgI2Gif6HJzORlj6Tc0mMjiNlWFzbRp7W4Bxtx',
// };

export const environment = {
  production: false,
  base_uri: 'https://qa.tools.tecnosystem.net.ve/api',
  base_uri_api_profit: 'https://qaapiprofit.sistealarmas.com:9876',
  base_uri_mikrowisp: 'https://demo.mikrosystem.net/api/v1',
  token_api_mikrowisp: 'Smx2SVdkbUZIdjlCUlkxdFo1cUNMQT09',
  token_api_profit: '1|GxmgI2Gif6HJzORlj6Tc0mMjiNlWFzbRp7W4Bxtx',
  token_api_tools: '1|GxmgI2Gif6HJzORlj6Tc0mMjiNlWFzbRp7W4Bxtx',
  pusher: {
    instanceId: '35d39b42-6686-42be-a0d1-7ed850d54f08',
  },
  version: {
    app_name: 'ngx-clientes-tecnosystem',
    version_code: 11,
    version_name: '1.0.11',
    release_date: '2024-11-13',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
